import BaseService from './BaseService'
export class UserService extends BaseService {
  // eslint-disable-next-line no-useless-constructor
  constructor (axios) {
    super(axios)
  }

  loginOut () {
    const url = '/hy-sb-userinfo/user/logout'
    return this.httpTool.get(url)
      .then((res) => {
        console.log(res.msg)
        return res.msg
      })
      .catch((err) => {
        console.log(err)
        return null
      })
  }

  loadTerminal (data) {
    const url = 'https://www.qyjiaxing.com/user/alogin'
    return this.httpTool.post(url, data)
      .then((response) => {
        console.log(response)
        return response
      })
      .catch(function (error) {
        console.log(error)
        return null
      })
  }

  loadShop (data) {
    const url = '/hy-sb-userinfo/user/login'
    return this.httpTool.post(url, data)
      .then((response) => {
        console.log(response)
        return response
      })
      .catch(function (error) {
        console.log(error)
        return null
      })
  }
  loadYZMTerminal (data) {
    const url = 'https://www.qyjiaxing.com/user/blogin'
    return this.httpTool.post(url, data)
      .then((response) => {
        console.log(response)
        return response
      })
      .catch(function (error) {
        console.log(error)
        return null
      })
  }
  loadYZM (data) {
    // 获取验证码用来登录
    const url = 'https://www.qyjiaxing.com/user/sendCode'
    return this.httpTool.post(url, data)
      .then((response) => {
        console.log(response)
        return response
      })
      .catch(function (error) {
        console.log(error)
        return null
      })
  }
  getUserAccount () {
    const url = '/hy-sb-userinfo/user/getUserInfo'
    return this.httpTool.get(url)
      .then((res) => {
        const { content: { loginName, name }} = res
        return { loginName: loginName, name: name }
      })
      .catch((err) => {
        console.log(err)
        return null
      })
  }
  changeUserInfo (data) {
    const url = '/hy-sb-userinfo/user/updateUserInfo'
    return this.httpTool.post(url, data)
      .then((res) => {
        if (res.code === '0') { // 成功
          return 0
        } else if (res.code === '2') { // 原密码错误
          return 2
        } else { // 修改失败
          return 1
        }
      })
      .catch((err) => {
        console.log(err)
        return null
      })
  }
}
